import React from 'react';
import { OktonPage } from '@okton/platform-ui';

// O shell já está na raiz; a página mantém somente o espaçamento compartilhado.
const BankAppPage: React.FC = ({ children }) => (
  <OktonPage style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
    {children}
  </OktonPage>
);

export default BankAppPage;
